import React from 'react';
import classes from './Footer.module.css';

const Footer = () => {
  return (
    <div>
      <footer className={classes.footer}>
        <ul>
          <li>
            <a
              href="https://github.com/starver20"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src="/assets/github.svg" alt="" />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/amar-narute-435540149/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src="/assets/linkedin.svg" alt="" />
            </a>
          </li>
          <li>
            <a
              href="https://amar-narute.netlify.app/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src="/assets/portfolio.svg" alt="" />
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/AmarNarute"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src="/assets/twitter.svg" alt="" />
            </a>
          </li>
        </ul>
        <h6>Made with ❤️ by Amar Narute</h6>
      </footer>
    </div>
  );
};

export default Footer;
